import React from "react";
import CommentSection from "../../../../../pages/Ordering/common/CommentSection";

const Comments = props => {
    return <div className="ordering-tab-wrapper">
        <CommentSection {...props} />
    </div>;
};

export default Comments;
